import * as Constants from "./constants";
/**
 * Actions pour la gestion de la session
 * @category Store
 * @hideconstructor
 */

var SessionStoreAction = /*#__PURE__*/function () {
  function SessionStoreAction() {}

  /**
   * RAZ de l'id de session
   */
  SessionStoreAction.resetSessionId = function resetSessionId() {
    return {
      type: Constants.SET_SESSION_ID,
      value: null
    };
  }
  /**
   * Mise à jour de l'id de session
   * @param {string} id Identifiant de session
   */
  ;

  SessionStoreAction.setSessionId = function setSessionId(id) {
    return {
      type: Constants.SET_SESSION_ID,
      value: id
    };
  }
  /**
   * Mise à jour de la date et heure de la dernière requête
   * @param {date} date Date et heure de la dernière requête
   */
  ;

  SessionStoreAction.setSessionLastRequest = function setSessionLastRequest(date) {
    return {
      type: Constants.LAST_REQUEST,
      value: date
    };
  }
  /**
   * Mise à jour de l'info de maintient ou non de la connexion
   * @param {boolean} stayConnect true pour maintenir la connexion, false sinon
   */
  ;

  SessionStoreAction.setSessionStayConnect = function setSessionStayConnect(stayConnect) {
    return {
      type: Constants.STAY_CONNECT,
      value: stayConnect
    };
  };

  return SessionStoreAction;
}(); // Exports


export var resetSessionId = SessionStoreAction.resetSessionId;
export var setSessionId = SessionStoreAction.setSessionId;
export var setSessionLastRequest = SessionStoreAction.setSessionLastRequest;
export var setSessionStayConnect = SessionStoreAction.setSessionStayConnect;